import type { ThemeName } from "@/modules/theme/allThemeNames.ts";
import type { ThemeModule } from "@/modules/theme/types.ts";
import * as atomidata from "@/styles/atomidata/theme.ts";
import * as cognovum from "@/styles/cognovum/theme.ts";
import * as contabo from "@/styles/contabo/theme.ts";
import * as daruur from "@/styles/daruur/theme.ts";
import * as dataxion from "@/styles/dataxion/theme.tsx";
import * as denvr from "@/styles/denvr/theme.ts";
import * as dimensicloud from "@/styles/dimensicloud/theme.ts";
import * as elisa from "@/styles/elisa/theme.ts";
import * as eslcloud from "@/styles/eslcloud/theme.ts";
import * as hostnic from "@/styles/hostnic/theme.ts";
import * as hostsailor from "@/styles/hostsailor/theme.ts";
import * as hostzop from "@/styles/hostzop/theme.tsx";
import * as hpe from "@/styles/hpe/theme.ts";
import * as idcloudhost from "@/styles/idcloudhost/theme.ts";
import * as kolodc from "@/styles/kolodc/theme.ts";
import * as metal from "@/styles/metal/theme.ts";
import * as nforce from "@/styles/nforce/theme.tsx";
import * as pilvio from "@/styles/pilvio/theme.ts";
import * as rackdog from "@/styles/rackdog/theme.ts";
import * as rackzar from "@/styles/rackzar/theme.ts";
import * as readyidc from "@/styles/readyidc/theme.tsx";
import * as serverwala from "@/styles/serverwala/theme.ts";
import * as stacklogic from "@/styles/stacklogic/theme.ts";
import * as telia from "@/styles/telia/theme.ts";
import * as tenbyte from "@/styles/tenbyte/theme.tsx";
import * as vdc from "@/styles/vdc/theme.ts";
import * as warren from "@/styles/warren/theme.ts";
import * as web1 from "@/styles/web1/theme.ts";

export let allThemes: Record<ThemeName, ThemeModule> = {
    atomidata,
    cognovum,
    daruur,
    denvr,
    dataxion,
    dimensicloud,
    hostnic,
    hostsailor,
    hostzop,
    idcloudhost,
    kolodc,
    metal,
    nforce,
    pilvio,
    rackdog,
    rackzar,
    readyidc,
    serverwala,
    stacklogic,
    tenbyte,
    vdc,
    warren,
    web1,
    hpe,
    telia,
    elisa,
    eslcloud,
    contabo,
};

//#region Hot reload support

/** @internal */
export function __setState(newAllThemes: typeof allThemes, newThemeListeners: typeof themeListeners) {
    allThemes = newAllThemes;
    themeListeners = newThemeListeners;
}

let themeListeners = new Set<() => void>();

export function addThemeListener(listener: () => void) {
    themeListeners.add(listener);
    return () => {
        themeListeners.delete(listener);
    };
}

/** @internal */
export function __notifyThemeListeners() {
    for (const listener of themeListeners) {
        try {
            listener();
        } catch (e) {
            console.error("Error in theme listener", e);
        }
    }
}

if (import.meta.hot) {
    import.meta.hot.accept((newModule: unknown) => {
        console.debug("Hot reload allThemes...");

        const newInit = newModule as typeof import("@/modules/theme/allThemes.ts");
        // Patch the old object with the new themes
        Object.assign(allThemes, newInit.allThemes);

        // Propagate the original object into the "future" (so new hot reloads will still patch the original object)
        newInit.__setState(allThemes, themeListeners);
        newInit.__notifyThemeListeners();
    });
}

//#endregion
